export default "__VITE_ASSET__BJKiZWRs__"